import React from 'react';
import './CreateAccountForm.scss';

const CreateAccountForm = ({
    email,
    password,
    name,
    mobile,
    handleMobileChange,
    handleNameChange,
    handleEmailChange,
    handlePasswordChange,
    handleSubmit
}) => {
    
    return (
        <div className="account-form">
            <div className="account-form__title-container">
                <p className="account-form__title">Create account</p>
            </div>
            <div className="account-form__container">
                <form className="account-form__form" onSubmit={handleSubmit}>
                    <input className="account-form__input" type="text" placeholder="Name" required="required" value={name} onChange={handleNameChange}></input>
                    <input className="account-form__input" type="password" placeholder="Password" required="required" value={password} onChange={handlePasswordChange}></input>
                    <input className="account-form__input" type="text" placeholder="Email" required="required"value={email} onChange={handleEmailChange}></input>
                    <input className="account-form__input" type="number" placeholder="Mobile" required="required" value={mobile} onChange={handleMobileChange}></input>
                    <button type="submit" className="account-form__button">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default CreateAccountForm;